export const DOCUMENT_PARTNER_RELATION_SAVED =
  "Charisma.Leasing.PublishedLanguage.Events.Partner.DocumentPartnerRelationSaved";
export const PARTNER_RELATION_SAVED = "Charisma.Leasing.PublishedLanguage.Events.Partner.PartnerRelationSaved";
export const DOCUMENT_PARTNER_RELATIONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Partner.DocumentPartnerRelationsInvalidated";
